/**
 * Represents a 'product added' e-commerce event https://segment.com/docs/connections/spec/ecommerce/v2/#product-added
 */
export interface ProductAdded {
  /**
   * The activity slug + the user's slug
   */
  cart_id: string;
  /**
   * The activity slug_id
   */
  product_id: string;
  /**
   * The activity uid
   */
  sku: string;
  /**
   * The activity's subject
   */
  category?: string;
  /**
   * The activity's title
   */
  name: string;
  /**
   * The leader's name
   */
  brand?: string;
  /**
   * The activity's format
   */
  variant: string;
  /**
   * Price ($) of the activity
   */
  price?: number;
  /**
   * Quantity of a product (always 1)
   */
  quantity: number;
  /**
   * Coupon code associated with a product (for example, MAY_DEALS_3)
   */
  coupon?: string;
  /**
   * Position in the product list (ex. 3)
   */
  position: number;
  /**
   * URL of the product page
   */
  url: string;
  /**
   * Image url of the product
   */
  image_url?: string;
  /**
   * Pricing offer applied
   */
  pricingOffer?: string;
  enroll_modal_type: EnrollModalType;
  prepay_user_type?: PrepayUserType;
  one_on_one?: {
    /**
     * The one on one time selected for scheduling.
     */
    time_selected?: string;
    /**
     * Whether or not the user had the 'When I cancel' option
     */
    is_recurring_schedule_available?: boolean;
    /**
     * Whether or not this checkout flow is for accepting a meeting request
     */
    is_accepting_meeting_request?: boolean;
    /**
     * Whether or not this checkout flow is adding meetings to a 1:1 or is a new enrollment
     */
    is_new_enrollment?: boolean;
  };
  /**
   * For one on one enrollments this is how many weeks they booked out for.
   */
  enrollmentDuration?: string;
  group_class?: {
    /**
     * The section uid selected for enrollment.
     */
    section_uid?: string;
    /**
     * The number of seats filled at time of opening the checkout form
     */
    seats_filled?: number;
    payment_option_type?: PaymentOptionType;
    /**
     * The price in cents for the recurring price shown, when applicable
     */
    recurring_option_price_cents?: number;
    /**
     * A list of the weeks available for selection when prepaying for a recurring group class
     */
    prepay_user_recurring_period_options?: string[];
    /**
     * Whether or not this is a purchase in a buyout section
     */
    is_buyout_section?: boolean;
  };
}

/**
 * The modal type for this checkout.
 */
export enum EnrollModalType {
  one_on_one = "one_on_one",
  group_class = "group_class",
  chat_groups = "chat_groups",
  join_waitlist = "join_waitlist",
  accept_gift_enrollment = "accept_gift_enrollment",
}
/**
 * The type of user checkout flow.
 */
export enum PrepayUserType {
  org_admin = "org_admin",
  charter_purchase_order = "charter_purchase_order",
  class_wallet = "class_wallet",
}
/**
 * Group class payment option type.
 */
export enum PaymentOptionType {
  recurring_or_upfront = "recurring_or_upfront",
  recurring_only = "recurring_only",
  upfront_only = "upfront_only",
}
